import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Paper,
} from '@material-ui/core'
import Cookies from 'universal-cookie'
import { Link, useHistory } from 'react-router-dom'
import { multiplePesticide } from '../../../redux-saga/User/MultiplePesticide/Reducer'
import CartComponent from '../../../components/Mobile/ProductCard/Cart'
import style from './index.module.css'
import Button from '../../../components/Mobile/Button'
import { cartItem } from '../../../redux-saga/User/Login/Reducer'
import { ROUTE } from '../../../utils/User/constants/routingConfig/routeDetails'
import { handleBuyAll } from '../../../utils/User/helper/functions'

const Cart = () => {
  const cookies = new Cookies()
  const history = useHistory()
  const [ isEmpty, setIsEmpty ] = useState(false)
  const [ total, setTotal ] = useState(0)
  const dispatch = useDispatch()
  const { multiPesticide } = useSelector((state) => state.multiPesticide)
  let ids = []

  const handleUpdate = (removeId = -1) => {
    const string = cookies.get('cart')
    ids = string && string.split('#')
    const updatedIds = []
    let updatedString = ''
    if (ids?.length) {
      ids.forEach((id) => {
        if (+id !== removeId) {
          updatedIds.push(id)
          if (updatedString !== '') {
            updatedString = `${ updatedString }#${ id }`
          } else {
            updatedString = `${ id }`
          }
        }
      })
      cookies.set('cart', updatedString, { path: ROUTE.HOME, Expires: 1000 * 60 * 24 * 365 })
    } else {
      cookies.remove('cart')
    }
    if (updatedIds?.length) {
      dispatch(cartItem(updatedIds?.length))
      dispatch(multiplePesticide(updatedIds))
    } else {
      dispatch(cartItem(null))
      setIsEmpty(true)
    }
  }

  useEffect(() => {
    if (multiPesticide?.length) {
      let amt = 0
      multiPesticide.forEach((pesti) => {
        amt += pesti?.price
      })
      setTotal(amt)
    }
  }, [ multiPesticide ])
  // const handleItemCount = (e, id) => {

  // }
  useEffect(() => {
    handleUpdate()
  }, [])

  return (
    <div className='container row'>
      { !isEmpty && (
        <>
          <div className='col-12 col-md-12'>
            {
              multiPesticide?.map((pesti) => (
                <CartComponent
                  key={ pesti?.id }
                  pesti={ pesti }
                  handleRemove={ () => handleUpdate(pesti?.id) }
                  history={ history }
                />
              ))
            }
          </div>
          <div className='col-12 col-md-12 text-center'>
            <p>Price Details</p>
            <p>
              Total Amount =
              { total }
            </p>
            <Button onClick={ () => handleBuyAll(multiPesticide, 'array', history) }>Place Order</Button>
          </div>
        </>
      )}
      {
        isEmpty && (
        <div className='col-md-12 col-12'>
          <div className={ style.empty }>
            <i className='fas fa-cart-plus fa-10x' />
          </div>
          <div className={ style.text }>
            <p>Your cart is empty</p>
          </div>
          <div className={ style.button }>
            <Link to={ ROUTE.PESTICIDES }><Button>Pack your bag</Button></Link>
          </div>
        </div>

        )
      }
    </div>
  )
}

export default Cart
